import React from 'react'

const NameLesson = () => {
    return (
        <div>
            <h1 className='namelesson'>Quritish va konservalash texnologik qurilmalari</h1>
        </div>
    )
}

export default NameLesson